import { Directive, OnInit } from "@angular/core";
import { Params } from "@angular/router";
import { DatabaseFilterParams } from "../common.model";

import { ListesideBaseClass } from "./listeside.component";

@Directive()
export abstract class DatabaserListesideBaseClass extends ListesideBaseClass {

  filterParams: DatabaseFilterParams = new DatabaseFilterParams();

  override urlParamsToFilterParams(params: Params, filterParams: DatabaseFilterParams): DatabaseFilterParams {

    const base = super.urlParamsToFilterParams(params, filterParams);

    return {
      ...base,
      types: params.types
        ? Array.isArray(params.types)
          ? params.types
          : [params.types]
        : []
    };
  }

  override onFilterChange(filterParams: DatabaseFilterParams): void {

    this.filterParams = filterParams;

    this.router.navigate([], {
      queryParams: {
        beskrivelse: filterParams.tekst,
        sortOrder: filterParams.order,
        pageNumber: filterParams.pageNumber,
        pageSize: filterParams.pageSize,
        types: filterParams.types,
        hasSystem: filterParams.hasSystem ?? null
      }
    });
  }
}
